import { GenericField, InputProps } from "../Fields/GenericField";
import { ComponentPropsWithoutRef } from "react";
import { useField } from "formik";
import { Textarea } from "@/components/catalyst/textarea";

export type TextAreaInputProps = InputProps & {
  textAreaProps?: ComponentPropsWithoutRef<"textarea">;
};

export function TextAreaInput({
  textAreaProps,
  autoFocus,
  ...props
}: TextAreaInputProps) {
  const [field, meta] = useField(props.name);
  const { value, ...rest } = field;
  const showError = !!meta.error && meta.touched;
  const maxLength = textAreaProps?.maxLength;
  const currentLength = (value || "").length;

  return (
    <GenericField
      {...props}
      viewNode={<div className="whitespace-pre-wrap">{value}</div>}
    >
      <Textarea
        {...textAreaProps}
        {...rest}
        autoFocus={autoFocus}
        value={value ?? ""}
        invalid={showError}
      />
      {maxLength ? (
        <div className="mt-1 text-right text-sm text-zinc-500">
          {currentLength}/{maxLength}
        </div>
      ) : null}
    </GenericField>
  );
}
